import { render, staticRenderFns } from "./Recite.vue?vue&type=template&id=6316a6ea&scoped=true&"
import script from "./Recite.vue?vue&type=script&lang=js&"
export * from "./Recite.vue?vue&type=script&lang=js&"
import style0 from "./Recite.vue?vue&type=style&index=0&id=6316a6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6316a6ea",
  null
  
)

component.options.__file = "Recite.vue"
export default component.exports